<template>
  <div style="padding-bottom:0px;">
    
    <van-field v-model="shareData.link" type="textarea" placeholder="请输入链接" />

    <div style="margin:20px 0" @click="show=true"><van-cell :value="`标题:${shareData.title}`" /></div>
    <van-popup v-model="show" position="bottom" :overlay="true">
      <van-picker show-toolbar @cancel="show=false" @confirm="onChange" :columns="titleList" />
    </van-popup>

    <div style="margin:0 0 20px">
      <van-uploader :after-read="onRead" accept="image/gif, image/jpeg">
        <img class="configShare_changeImg" :src="shareData.imgSrc" alt="">
      </van-uploader>
    </div>

    <van-field label="朋友圈文案" disabled />
    <van-list>
      <van-cell
        v-for="item in list"
        :key="item"
        v-clipboard:copy="item"
        v-clipboard:success="onCopy"
        :title="item"
      />
    </van-list>

    <div style="'width:100%;height:30px"></div>
    <van-field label="评论文案" disabled />
    <van-list>
      <van-cell
        v-for="item in commentList"
        :key="item"
        v-clipboard:copy="item"
        v-clipboard:success="onCopy"
        :title="item"
      />
    </van-list>

    <div class="configShare_bottom">
      <van-button class="configShare_shareBtn" type="info" plain @click="createShare">生成分享</van-button>
    </div>
    

  </div>
</template>

<script>
  import wxShare from "@/assets/js/wx.share"
  import { Toast } from 'vant';
    import myApi from '@/axios/my'
export default {
  name: 'configShareIndex',

  data() {
    return {
      shareData: {
        link: 'http://mi.baozheng.cc/bagGame',
        title: '一生要强的中国女人，这该死的胜负欲！',
        imgSrc: 'https://baozheng-nice-new.baozheng.cc/uploads/content/file/data/000/000/097/4452b221.jpg'
      },
      titleList:[
        '一生要强的中国女人，这该死的胜负欲！'
      ],
      list: [
        '朋友圈文案1111'
      ],
      commentList: [
        '评论文案1111',
        '评论文案2222',
        '评论文案3333',
      ],
      show: false,
    }
  },
  created(){

  },
  methods: {
    toKefu() {
      window.location.href="https://work.weixin.qq.com/kfid/kfccf7d7a3ddc2f9dca"
    },

    onRead(file, detail) {
      console.log(file)
      let formData = new FormData()
        formData.append('file', file.file)
        myApi.uploadImg(formData)
          .then(res=>{
            console.log('成功',res)
            this.shareData.imgSrc = res.template
          })
    },

    onChange(value) {
      this.shareData.title = value
      this.show = false
    },
    onCopy() {
      Toast('复制成功')
    },
    createShare() {
      let shareData = this.shareData
      let shareBody = {
        desc: '包拯',
        title: shareData.title,
        imgUrl: shareData.imgSrc?shareData.imgSrc:'',
        link : shareData.link?shareData.link:'http://mi.baozheng.cc'
      };
      wxShare(shareBody)
          Toast.loading({
            message: '请稍等...',
            duration: 0,
            forbidClick: true, // 禁用背景点击
          })
          setTimeout(()=>{
            Toast('成功，请点击右上角然后分享到朋友圈');
          },1000)
    }
  }
}
</script>

<style scoped>
.zjb_iframe{
  border: none;
  width: 100%;
  height: 100vh;
}
.configShare_bottom{
  width: 50%;
  position: fixed;
  bottom: 20px;
  left: 25%;
  height: 100px;
  background-color: transparent;
  padding-bottom: env(safe-area-inset-bottom);
}
.configShare_kefuBtn{
  width: 230px;
  height: 72px;
  box-sizing: border-box;
  padding-right: 40px;
  border-radius: 36px;
  color: white;
  text-align: right;
  line-height: 72px;
  display: block;
  margin: 0 auto;
  font-size: 28px;
  font-weight: 600;
  background: url('https://img.chenzhen.shop/2022/03/15/5514a9e3-9790-4845-9a8e-4ed409fe2ee8.jpg') no-repeat;
  background-position: 34px 16px;
  background-size: 38px;
  background-color: rgb(27,169,76);
}
.configShare_shareBtn{
  margin: 0 auto;
  display: block;
  width: 90%;
}
.configShare_changeImg{
  width: 150px;
  height: 150px;
  display: block;
  margin: 20px 20px 0;
  border: 1px dashed #999;
}

</style>